import React, { useEffect } from 'react';
import UserPreview from './UserPreview';
import TeamPreview from './TeamPreview';
import { c, h } from '@debbie/cortex/dist';
import { useSelector } from 'react-redux';
import { selectAllUsers } from '@debbie/cortex/dist/users/selectors';
import { useTeams } from '@debbie/cortex/dist/teams';
const ResponsiblePreview = (props) => {
    const { responsibleType, responsibleReferenceId, style, active, onClick } = props;
    const allUsers = useSelector(selectAllUsers);
    const allTeamsLoadable = useTeams();
    const allTeams = h.hasData(allTeamsLoadable) ? allTeamsLoadable.data : null;
    const user = (allUsers || []).find((t) => t.id === responsibleReferenceId);
    const team = (allTeams || []).find((t) => t.id === responsibleReferenceId);
    useEffect(() => {
        if (!allUsers) {
            c.users.getAll();
        }
    }, [responsibleReferenceId, responsibleType]);
    return (React.createElement("div", null, responsibleType === 'user'
        ? user && (React.createElement(UserPreview, { user: user, active: active, onClick: onClick, style: style }))
        : team && (React.createElement(TeamPreview, { team: team, active: active, onClick: onClick, style: style }))));
};
export default ResponsiblePreview;
//# sourceMappingURL=ResponsiblePreview.js.map